import { Injectable } from '@angular/core';
import { 
  AuthStatePersistenceService, 
  AuthStorageService, 
  StatePersistenceService, 
  UserIdService, 
  AuthRedirectStorageService
} from '@spartacus/core';
import { combineLatest, Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

/**
 * Overrides the default Spartacus behavior that deletes the refresh_token from localStorage.
 * Without the refresh_token in the storage, angular-oauth2-oidc cannot perform the silent refresh
 * when reloading the page or opening a new tab.
 */
@Injectable({
  providedIn: 'root'
})
export class CustomAuthStatePersistenceService extends AuthStatePersistenceService {

  constructor(
    protected override statePersistenceService: StatePersistenceService,
    protected override userIdService: UserIdService,
    protected override authStorageService: AuthStorageService,
    protected override authRedirectStorageService: AuthRedirectStorageService
  ) {
    super(statePersistenceService, userIdService, authStorageService, authRedirectStorageService);
  }

  /**
   * Gets and transforms state from different sources into the form that should
   * be saved in storage.
   */
  protected override getAuthState(): Observable<any> {
    return combineLatest([
      this.authStorageService.getToken().pipe(
        filter((state) => !!state),
        map((state) => {
          return {
            ...state,
          };
        })
      ),
      this.userIdService.getUserId(),
      this.authRedirectStorageService.getRedirectUrl(),
    ]).pipe(
      map(([authToken, userId, redirectUrl]) => {
        let token = authToken;
        if (token) {
          token = { ...token };
          // Native Spartacus does: delete token.refresh_token;
          // We keep the refresh_token for the Authorization Code flow with PKCE to work.
        }
        return { token, userId, redirectUrl };
      })
    );
  }
}
